<template>
  <div class="section section-tramites-detalle">
    <div class="container">
      <h2></h2>
     <p>Nos complace anunciarte la próxima apertura de nuestro Centro Medico Odontológico, en sus renovadas instalaciones, de Lunes a Viernes con amplios horarios de atención.</p>
     <p> <span> <i class="now-ui-icons location_pin"></i> Ecuador 949, CABA</span></p>
     <p> <span> <i class="now-ui-icons tech_mobile"></i> (011) 2034 - 1000</span></p>
                 
      <div id="tramites-detalle">
        <div class="row">
          <div class="col-md-12">
            <tabs pills type="primary">
              <tab-pane label="Centro Médico" center>
              
           
                <h3>Especialidades</h3>
                <ul>
                    <li>Cardiología</li>
                    <li>Cirugía Cardiovascular</li>
                    <li>Cirugía General, Aparato Digestivo</li>
                    <li>Clinica Medica</li>
                    <li>Dermatología</li>
                    <li>Diabetología</li>
                    <li>Endocrinología</li>
                    <li>Ecodoppler cardíaco</li>
                    <li>Flebología</li>
                    <li>Ginecología</li>
                    <!-- <li>Ginecología Y Obstetricia</li> -->
                    <!-- <li>Nefrología</li> -->
                    <li>Neumonología</li>
                    <li>Neurología</li>
                    <li>Nutrición</li>
                    <li>Traumatología (cadera, miembros inferiores, hombro, rodilla, pie)</li>
                    <li>Urología</li>
                </ul>
              <!--  <p>En esta oportunidad queremos informarle que tanto en la Clínica Odontológica APM (Ecuador 949 C.A.B.A.) así como en las Seccionales Norte, Noroeste, Sur, Sudoeste y Oeste, cuentan con el servicio de cobro con tarjetas de débito y crédito para el pago de los trabajos odontológicos (prótesis y ortodoncia) para todos los afiliados y su grupo familiar.</p>
                <p>Aceptamos: Visa, MasterCard. American Express bancaria. </p>
                <p>Los pagos se podrán hacer hasta en 3 cuotas.</p>-->
              
              </tab-pane>
               <tab-pane label="Odontología" center>
           <!--     <p> <span> <i class="now-ui-icons location_pin"></i> Ecuador 949, CABA</span></p>
                <p> <span> <i class="now-ui-icons tech_mobile"></i> (011) 2034 - 1000</span></p>-->
<!--                <p> <span> <i class="now-ui-icons tech_watch-time"></i> Lunes a Viernes de 09 a 20 hs</span></p>-->
                
                <h3>Especialidades</h3>
                <ul>
                    <li>Odontología general</li>
                    <li>Odontopediatría</li>
                    <li>Periodoncia</li>
                    <li>Ortodoncia</li>
                    <li>Prótesis</li>
                    <li>Implantes</li>
                    <li>Radiología dental</li>
                    <li>Cirugías</li>
                </ul>
                <p>En esta oportunidad queremos informarle que tanto en la Clínica Odontológica APM (Ecuador 949 C.A.B.A.) así como en las Seccionales Norte, Noroeste, Sur, Sudoeste y Oeste, cuentan con el servicio de cobro con tarjetas de débito y crédito para el pago de los trabajos odontológicos (prótesis y ortodoncia) para todos los afiliados y su grupo familiar.</p>
                <p>Aceptamos: Visa, MasterCard. American Express bancaria. </p>
                <p>Los pagos se podrán hacer hasta en 3 cuotas.</p>
              </tab-pane>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Tabs, TabPane } from "@/components";

export default {
  components: {
    Card,
    Tabs,
    TabPane
  },
  data() {
    return {
      tramites: []
    };
  }//,
 // mounted() {
 //   this.$zaiq()
 //     .get("Tramite/GetAll")
 //     .then(response => {
       // console.log(response.data.result.items);
 //       this.tramites = response.data.result.items;
 //     });
 // }
};
</script>
<style scoped>
div.section {
  padding: 0px 0;
}
ul{
    font-weight: 300;
}
</style>

